import React from 'react';

// Company icons
import METAMASK from '../img/logos_company/MetaMask@1.5x.png';
import GNOSIS from '../img/logos_company/Gnosis@1.5x.png';
import COINBASE from '../img/logos_company/Coinbase@1.5x.png';
import QUICKBOOKS from '../img/logos_company/Quickbooks@1.5x.png';
import SHAKEPAY from '../img/logos_company/ShakePay@1.5x.png';
import ANCHORAGE from '../img/logos_company/Anchorage@1.5x.png';

// Types
import { TODO, ProviderTypes } from '../types';

export default function useProviders() {
  const providers = [
    {
      name: 'Metamask',
      id: 'metamask',
      image: METAMASK,
      type: ProviderTypes.WALLET,
    },
    {
      name: 'Gnosis Safe',
      id: 'gnosis',
      image: GNOSIS,
      type: ProviderTypes.CUSTODIAN,
    },
    // {
    //   name: 'Coinbase',
    //   id: 'coinbase',
    //   image: COINBASE,
    // },
    // {
    //   name: 'QuickBooks',
    //   id: 'quickBooks',
    //   image: QUICKBOOKS,
    // },
    // {
    //   name: 'Shakepay',
    //   id: 'shakepay',
    //   image: SHAKEPAY,
    // },
    {
      name: 'Anchorage',
      id: 'anchorage',
      image: ANCHORAGE,
      type: ProviderTypes.CUSTODIAN,
    },
  ];

  const getXUsingY = (x: string, y: TODO, yShouldEqualTo: TODO) => {
    const provider: TODO = providers.find((provider: TODO) => provider[y] === yShouldEqualTo);

    if (provider) {
      return provider[x];
    }

    return null;
  };

  return {
    providers,
    getImageUsingName: (name: string) => getXUsingY('image', 'name', name),
    getImageUsingID: (id: string) => getXUsingY('image', 'id', id),
    getNameUsingID: (id: string) => getXUsingY('name', 'id', id),
    getIDUsingName: (name: string) => getXUsingY('id', 'name', name),
  };
}
